export default {
      id: "Icon--users-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--users",
      toString: function () {
        return this.url;
      }
    }